var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"TableProfit"},[_vm._m(0),_c('div',[_c('profit',{attrs:{"id":_vm.iiid,"currdate":_vm.dateType,"partition":_vm.partition},on:{"search":_vm.search}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"txt-333 font-w card-title"},[_c('div',[_vm._v("各回收旧机利润排行")]),_c('div')])
}]

export { render, staticRenderFns }